import type { Quest } from 'types/quests'

type BreadcrumbPermsEligibility = {
    quest?: Pick<Quest, 'id' | 'side_quest'> | null
    parentQuestId?: string | null
    isPublic: boolean
    isBsv: boolean
    isOwner: boolean
}

export function canPublishFromQuestBreadcrumb({
    quest,
    parentQuestId,
    isPublic,
    isBsv,
    isOwner,
}: BreadcrumbPermsEligibility): boolean {
    return !!(quest?.id && !quest.side_quest && !parentQuestId && !isPublic && !isBsv && isOwner)
}
